import React, {useContext, useEffect, useState} from "react";
import "../styles/styles.css"
import Error from "./Error";
import EnvCtx from "../contexts/EnvCtx";
import { useTranslation } from 'react-i18next'
import cameraCntx from "../contexts/CameraCntx";

const SezioneB = () => {
    const { cciaa } = useContext(EnvCtx);
    const { t } = useTranslation();
    let chiaveSezione = "B";
    const [isOpen, setIsOpen] = useState(true);
    const [formulaInput, setFormulaInput] = useState('');
    const [formulaInputErrorKey, setFormulaInputErrorKey] = useState(null);
    const [formulaInputErrorOptions, setFormulaInputErrorOptions] = useState(null);
    const {selectedMediazione, selectedIva, sezioneB, liteB, selectedLiteA, selectedLiteB, setSelectedLiteB, tipiSpesaB, selectedTipoSpesaB,
        setSelectedTipoSpesaB, selectedRadioB, setSelectedRadioB, listValoreB, setListValoreB, totaleB, error, showErrorB, setShowErrorB,
        setShowErrorC, liteBdanger, setLiteBdanger, radioBdanger, setRadioBdanger, getLitiByCameraAndPadre, getValoreSpesa, getCalculatedValoreByFormulaMediazioneVolontaria, getCalculatedValoreByFormulaMediazioneObbligatoria,
        handleErrorClick, formatNumber, getDescrizioneByLingua, getSottoTitoloByLingua, getTestoSezioneByLingua, getDescrizioneLivelloByLingua} = useContext(cameraCntx);

    const performCalculation = async (inputValue) => {
        let result;
        if (selectedMediazione.chiave === "mediazione1") {
            result = await getCalculatedValoreByFormulaMediazioneObbligatoria(chiaveSezione, selectedLiteA.id, selectedLiteB.id, inputValue);
        } else {
            result = await getCalculatedValoreByFormulaMediazioneVolontaria(chiaveSezione, selectedLiteA.id, selectedLiteB.id, inputValue);
        }
        if (result) {
            const syntheticTipoSpesa = {
                tipo: 'formula',
                valore: {
                    conIva: parseFloat(result.valoreConIva),
                    senzaIva: parseFloat(result.valoreSenzaIva),
                },
            };
            setListValoreB([syntheticTipoSpesa]);
            setSelectedTipoSpesaB(syntheticTipoSpesa);
        }
    };

    useEffect(() => {
        if (selectedLiteA) {
            getLitiByCameraAndPadre(chiaveSezione);
        }
    }, [selectedLiteA, getLitiByCameraAndPadre, chiaveSezione]);

    useEffect(() => {
        setListValoreB([]);
        if (selectedLiteB) {
            if (selectedLiteB.tipo === 'indeterminato') {
                const defaultValue = String(selectedLiteB.valoreControversiaDefault);
                setFormulaInput(defaultValue);
                performCalculation(defaultValue);
            } else {
                setFormulaInput('');
            }
            if (selectedLiteB.tipo !== 'formula' && selectedLiteB.tipo !== 'indeterminato') {
                const fetchData = async () => {
                    let risultatiValori = await Promise.all(tipiSpesaB.map(async (tipo) => {
                        if (selectedLiteB.id) {
                            const valoreSpesa = await getValoreSpesa(selectedMediazione, selectedLiteB.id, chiaveSezione, tipo.chiave);
                            return {
                                tipo: tipo.chiave,
                                valore: {
                                    conIva: parseFloat(valoreSpesa.conIva),
                                    senzaIva: parseFloat(valoreSpesa.senzaIva)
                                },
                            };
                        }
                        return null;
                    }));
                    risultatiValori = risultatiValori.filter((risultato) => risultato !== null);
                    setListValoreB(risultatiValori);
                };
                fetchData();
            }
        } else {
            setFormulaInput('');
        }
    }, [selectedMediazione, selectedLiteB, chiaveSezione, tipiSpesaB, getValoreSpesa]);

    useEffect(() => {
        if (selectedTipoSpesaB?.tipo === 'formula') {
            return;
        }
        if (tipiSpesaB.length > 1 && selectedLiteB) {
            tipiSpesaB.forEach(tipo => {
                if (selectedRadioB && selectedRadioB.chiave === tipo.chiave && listValoreB && listValoreB.length > 0) {
                    setSelectedTipoSpesaB(listValoreB.find(item => item.tipo === tipo.chiave));
                }
            })
        } else if (tipiSpesaB.length === 1 && selectedLiteB) {
            tipiSpesaB.forEach(tipo => {
                if (listValoreB && listValoreB.length > 0) {
                    setSelectedTipoSpesaB(listValoreB.find(item => item.tipo === tipo.chiave));
                }
            })
        } else {
            setSelectedTipoSpesaB(null);
        }
    }, [selectedLiteB, tipiSpesaB, listValoreB, selectedRadioB, setSelectedTipoSpesaB]);

    const handleCalculateClick = async () => {
        if (!selectedLiteB) {
            setFormulaInputErrorKey('sezioneB.error.select_controversia');
            return;
        }

        const { minLivello, maxLivello } = selectedLiteB;
        const min = parseFloat(minLivello);
        const max = parseFloat(maxLivello);
        const val = parseFloat(formulaInput);

        const minError = min.toLocaleString('it-IT', {useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const maxError = max.toLocaleString('it-IT', {useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 });


        if (isNaN(val) || val <= 0) {
            setFormulaInputErrorKey('sezioneB.error.invalid_value');
            return;
        }

        if (min && max && (val < min || val > max)) {
            setFormulaInputErrorKey('sezioneB.error.value_between');
            setFormulaInputErrorOptions({ minError, maxError });
            return;
        } else if (min && !max && val < min) {
            setFormulaInputErrorKey('sezioneB.error.value_greater_than');
            setFormulaInputErrorOptions({ minError });
            return;
        } else if (!min && max && val > max) {
            setFormulaInputErrorKey('sezioneB.error.value_less_than');
            setFormulaInputErrorOptions({ maxError });
            return;
        } else {
            setFormulaInputErrorKey(null);
            setFormulaInputErrorOptions(null);
        }

        performCalculation(formulaInput);
    };

    if (!sezioneB) return null;

    const sottoTitolo = getSottoTitoloByLingua(sezioneB)?.trim();

    const testo = getTestoSezioneByLingua(sezioneB)?.trim();

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const handleSelectChange = (event) => {
        setSelectedLiteB(liteB.find(item => item.id === parseInt(event.target.value, 10)));
        setShowErrorB(false);
        setShowErrorC(false);
        setLiteBdanger(false);
    };

    const handleTipoSpesaBChange = (event) => {
        setSelectedRadioB(tipiSpesaB.find(item => item.chiave === event.target.value));
        setShowErrorC(false);
        setRadioBdanger(false);
    };

    const handleFormulaInputChange = (e) => {
        const value = e.target.value;
        setFormulaInput(value);
        setFormulaInputErrorKey(null);
        setFormulaInputErrorOptions(null);
    };

    const formulaInputError = formulaInputErrorKey ? t(formulaInputErrorKey, formulaInputErrorOptions) : "";

    return (
        <div className="accordion sezione-accordion" id="accordionSezionB" style={{backgroundColor: cciaa ? cciaa.background_colore : ""}}>
            <div className="accordion-item">
                <h2 className="accordion-header">
                    <button
                        className={`accordion-button sezione-accordion-button ${
                            isOpen ? "" : "collapsed"
                        }`}
                        type="button"
                        onClick={toggleAccordion}
                        aria-expanded={isOpen ? "true" : "false"}
                        aria-controls="panelcollapseSezioneB"
                        style={{backgroundColor: cciaa ? cciaa.background_colore : ""}}
                    >
                        <span>{sezioneB.chiave}. {getDescrizioneByLingua(sezioneB)}</span>
                    </button>
                </h2>
                <div id="panelcollapseSezioneB" className={`accordion-collapse ${isOpen ? "show" : "hidden"}`}>
                    <div className={`accordionBody sezione-accordion-body`}>
                        <div>
                            <div className="col-8">
                                <div className="row">
                                    <div className="col-6"> <label className="sezione-label">{t("sezioneB.valore_controversia")}</label> </div>
                                    <div className="col-6"> {error && showErrorB && <Error errors={[error]} />} </div>
                                </div>
                            </div>
                            <div className="sezione-div-error">
                                <div className={`invisible_div ${(!selectedMediazione || !selectedLiteA) ? 'select-error-calc' : ''}`} onClick={() => handleErrorClick(chiaveSezione)}></div>
                                {liteB ? (
                                    <select className={`form-select form-select-lg mb-3 sezione-select ${liteBdanger ? 'border-danger' : ''}`} aria-label="Default select" value={selectedLiteB ? selectedLiteB.id : ''}
                                            onChange={handleSelectChange} disabled={!selectedMediazione || !selectedLiteA}>
                                        <option disabled value="">{t("sezioneB.select_message")}</option>
                                        {liteB && liteB.map((item, index) => (
                                            <option key={index} value={item.id}>{getDescrizioneLivelloByLingua(item)}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <select className={`form-select form-select-lg mb-3 sezione-select ${liteBdanger ? 'border-danger' : ''}`} aria-label="Default select" onChange={handleSelectChange}>
                                        <option disabled selected>{t("sezioneB.select_message")}</option>
                                    </select>
                                )}
                            </div>
                        </div>
                        {selectedLiteB && (selectedLiteB.tipo === 'formula' || selectedLiteB.tipo === 'indeterminato') && (
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <div className="input-group">
                                        <span className="input-group-text">€</span>
                                        <input
                                            type="number"
                                            className={`form-control ${formulaInputError ? 'is-invalid' : ''}`}
                                            value={formulaInput}
                                            onChange={handleFormulaInputChange}
                                            placeholder="Inserire valore"
                                            disabled={selectedLiteB.tipo === 'indeterminato'}
                                        />
                                        {selectedLiteB.tipo === 'formula' && (
                                            <button className="btn btn-primary" onClick={handleCalculateClick} style={{backgroundColor: cciaa ? cciaa.background_colore : "", borderColor: cciaa ? cciaa.background_colore : ""}}>
                                                Calcola
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className="col-12">
                                    {formulaInputError && <div className="invalid-feedback d-block">{formulaInputError}</div>}
                                </div>
                            </div>
                        )}
                        <div>
                        </div>
                        {selectedMediazione && tipiSpesaB.length > 1 ? (
                            <>
                                <div className="row mb-1">
                                    {testo ? (
                                        <div className="col-md-9">
                                            <p className="sezione-italic"> {testo}</p>
                                        </div>
                                    ) : null}

                                    <div className="col-md-3 d-flex align-items-center justify-content-right">
                                        {selectedTipoSpesaB && (
                                            <div className="col-md-3 d-flex align-items-center justify-content-right" key={selectedTipoSpesaB.tipo.chiave}>
                                                <span className="badge rounded-pill text-bg-light sezione-span">
                                                    <span className="con-iva">
                                                        € {selectedIva === "IVA_inclusa" ? formatNumber(selectedTipoSpesaB.valore.conIva) : formatNumber(selectedTipoSpesaB.valore.senzaIva)}
                                                    </span>
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    {tipiSpesaB.map((item, index) => (
                                        <div className="col-md-4 d-flex align-items-center justify-content-right sezione-div-error" key={index}>
                                            <div className={`invisible_div ${!selectedLiteB ? 'radioinput-error-cal' : ''} mt-1 me-2 mb-1`} onClick={() => handleErrorClick(chiaveSezione)}></div>
                                            <div className="form-check">
                                                    <input
                                                        className={`form-check-input ${(radioBdanger) ? 'border-danger' : ''}`}
                                                        type="radio"
                                                        id={`tipoSpesa_${item.id}`}
                                                        name="spesab_radio"
                                                        value={item.chiave}
                                                        onChange={handleTipoSpesaBChange}
                                                        checked={selectedRadioB && selectedRadioB.chiave === item.chiave}
                                                        disabled={!selectedLiteB}
                                                    />
                                                <label className="form-check-label" htmlFor={`tipoSpesa_${item.id}`}>{getDescrizioneByLingua(item)}</label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-9">
                                        <p className="sezione-total">{t("sezioneB.totale")}</p>
                                    </div>
                                    { selectedTipoSpesaB && (
                                        <div className="col-md-3 d-flex align-items-center justify-content-right">
                                            <span className="badge rounded-pill text-bg-light sezione-total">
                                                € {formatNumber(totaleB)}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <div>
                                    <p className="sezione-p">{t("sezioneB.message_aviso")}</p>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="row mb-1">
                                    {testo ? (
                                        <div className="col-md-9">
                                            <p className="sezione-italic"> {testo}</p>
                                        </div>
                                    ) : null}
                                    <div className="col-md-3 d-flex align-items-center justify-content-right">
                                        {selectedTipoSpesaB && (
                                            <div className="col-md-3 d-flex align-items-center justify-content-right" key={selectedTipoSpesaB.tipo.chiave}>
                                                <span className="badge rounded-pill text-bg-light sezione-span">
                                                    <span className="con-iva">
                                                        € {selectedIva === "IVA_inclusa" ? formatNumber(selectedTipoSpesaB.valore.conIva) : formatNumber(selectedTipoSpesaB.valore.senzaIva)}
                                                    </span>
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-9">
                                        <p className="sezione-total">{t("sezioneB.totale")}</p>
                                    </div>
                                    {selectedTipoSpesaB && (
                                        <div className="col-md-3 d-flex align-items-center justify-content-right">
                                            <span className="badge rounded-pill text-bg-light sezione-total">
                                                € {formatNumber(totaleB)}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {sottoTitolo ? (
                                    <div className="font-italic mt-2">
                                        <p className="sezione-p"> {sottoTitolo}</p>
                                    </div>
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SezioneB;
